"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserDivisions {
}
exports.UserDivisions = UserDivisions;
//# sourceMappingURL=UserDivisions.js.map